export function changeDataTableScrollSizeOnHoverByRef (wrapper, container) {
  if (!wrapper || !container) return

  function handleMouseMove (e) {
    const isOverVerticalScroll =
        e.offsetX > wrapper.clientWidth - 10 && wrapper.scrollHeight > wrapper.clientHeight

    const isOverHorizontalScroll =
        e.offsetY > wrapper.clientHeight - 10 && wrapper.scrollWidth > wrapper.clientWidth

    if (isOverVerticalScroll) {
      container.classList.add('scrolling-vertical')
    } else if (isOverHorizontalScroll) {
      container.classList.add('scrolling-horizontal')
    } else {
      container.classList.remove('scrolling-vertical')
      container.classList.remove('scrolling-horizontal')
    }
  }

  function handleMouseLeave () {
    container.classList.remove('scrolling-vertical')
    container.classList.remove('scrolling-horizontal')
  }

  wrapper.addEventListener('mousemove', handleMouseMove)
  wrapper.addEventListener('mouseleave', handleMouseLeave)

  return () => {
    wrapper.removeEventListener('mousemove', handleMouseMove)
    wrapper.removeEventListener('mouseleave', handleMouseLeave)
  }
}
